"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = require("../js/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WrappedIcon = function WrappedIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      "svg",
      { className: "spectrum-UIIcon-HelpMedium" },
      _react2.default.createElement("path", { d: "M9 1C4.6 1 1 4.6 1 9s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm1.3 12.3c0 .3-.1.7-.3.9-.2.2-.6.3-.9.3-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2c.8 0 1.3.5 1.2 1.2zm.1-4.5c-.4.4-.8.8-.8 1.2 0 .3.1.6.3.8v.1c0 .1 0 .1-.1.1H8.4c-.1 0-.2 0-.2-.1-.3-.3-.4-.7-.4-1.1.1-.7.5-1.3 1-1.7s.9-1 1-1.7c0-.5-.4-1.1-1.4-1.1-.7 0-1.4.1-2 .4h-.2V4.3c0-.1 0-.2.1-.2.8-.3 1.6-.5 2.4-.5 1.9 0 3.1 1.1 3.1 2.7-.1 1-.6 1.9-1.4 2.5z", className: "spectrum-UIIcon--medium" }),
      _react2.default.createElement("path", { d: "M11 .7C5.5.7 1 5.2 1 10.8S5.5 21 11 21s10-4.6 10-10.2S16.5.7 11 .7zm1.6 15.6c0 .4-.1.8-.4 1.1-.3.3-.7.4-1.1.4-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5c1 0 1.7.6 1.5 1.5zm.2-5.7c-.5.5-1 1-1 1.5 0 .4.1.7.4 1v.1c0 .1-.1.1-.1.1h-1.8c-.1 0-.2 0-.2-.1-.3-.4-.5-.9-.5-1.4.1-.9.6-1.6 1.2-2.2.7-.5 1.1-1.3 1.2-2.2 0-.6-.5-1.4-1.8-1.4-.9 0-1.7.2-2.5.5h-.2V4.9c0-.1 0-.3.1-.3.9-.4 2-.6 3-.6 2.4 0 3.9 1.4 3.9 3.4-.1 1.3-.8 2.4-1.7 3.2z", className: "spectrum-UIIcon--large" })
    )
  );
};

WrappedIcon.displayName = 'HelpMedium';
exports.default = WrappedIcon;

